"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var fuzzyscore_1 = __importDefault(require("@zapier/common-utils/dist/fuzzyscore"));
var constants_1 = require("./constants");
var queryScore = lodash_1.curry(function (query, service) {
    return -fuzzyscore_1.default(query, service[constants_1.NAME]);
});
exports.default = queryScore;
